import React, { Component } from 'react';
import { Button, Row, Col, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class WorkflowTypes extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            workflowType: '',
            workflowTypes: [],
            unsavedChanges: false
        }
    };

    componentDidMount = () => {
        this.getWorkflowTypes();
    }

    getWorkflowTypes = () => {
        fetch('/api/workflows/types/', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    unsavedChanges: false,
                    workflowTypes: results.data
                })
            })
    }

    handleSubmit = () => {
        fetch('/api/workflows/types/', {
            method: 'POST',
            body: JSON.stringify({ workflowTypeLabel: this.state.workflowType }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success) {
                    this.setState({
                        workflowType: '',
                        unsavedChanges: false
                    }, () => this.getWorkflowTypes())
                }
            })
    }

    handleDelete = (workflowTypeId) => {
        fetch('/api/workflows/types/' + workflowTypeId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(() => {
                this.getWorkflowTypes();
            })
    }

    render() {
        return (
            <Row>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <Col>
                    <Row>
                        <Col>
                            <Label>Workflow Type
                                <Input
                                    type="text"
                                    name="workflowType"
                                    value={this.state.workflowType}
                                    onChange={(e) => this.setState({ workflowType: e.target.value, unsavedChanges: true })}
                                ></Input>
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className="mt-4"
                                disabled={this.state.workflowType === ''}
                                color="primary"
                                onClick={this.handleSubmit}
                            >Submit</Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    {this.state.workflowTypes.sort((a, b) => {
                        var textA = a.workflowTypeLabel?.toUpperCase();
                        var textB = b.workflowTypeLabel?.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }).map(workflowType => (
                        <Row key={workflowType.workflowTypeId} className="text-left mt-3">
                            <Col md={6}>
                                {workflowType.workflowTypeLabel}
                            </Col>
                            <Col md={6}>
                                <ConfirmButton className="mx-1" color="danger" onClick={() => this.handleDelete(workflowType.workflowTypeId)} title="Delete Workflow Type">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>
                            </Col>
                        </Row>
                    ))}
                </Col>
            </Row>
        );
    }
}

export default WorkflowTypes;
